import type { AnyFieldApi } from '@tanstack/react-form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

interface OptionSelectProps {
  field: AnyFieldApi;
  options: readonly { value: string; label: string }[];
  label: string;
  placeholder?: string;
  invalid: boolean;
  /** Labels a leading item that empties an optional field, offered once something is picked. */
  clearLabel?: string;
}

// Radix reserves '' for "nothing picked", so the clear item needs a value of its own.
const CLEAR_VALUE = '__clear__';

export function OptionSelect({ field, options, label, placeholder, invalid, clearLabel }: OptionSelectProps) {
  const value = (field.state.value as string | undefined) ?? '';

  return (
    <Select value={value} onValueChange={(next) => field.handleChange(next === CLEAR_VALUE ? '' : next)}>
      <SelectTrigger aria-label={label} aria-invalid={invalid || undefined} onBlur={field.handleBlur}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {clearLabel && value !== '' && <SelectItem value={CLEAR_VALUE}>{clearLabel}</SelectItem>}
        {options.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
